import clsx from 'clsx'
import { type ComponentPropsWithoutRef } from 'react'

import { withPublicImageUrl } from '@lib/utils/cdn'
import { hasFileExtension } from '@lib/utils/file'

import { type Asset, AssetGrid } from '@components/asset-grid/asset-grid'
import { Section } from '@components/ui-core/section/section'

import { type IImage } from '@custom/shared/types'

import styles from './trusted-by.module.scss'

interface TrustedByProps extends ComponentPropsWithoutRef<'div'> {
  data?: {
    heading?: string
    logos?: IImage[]
  }
  readonly className?: string
}

export const TrustedBy = ({ data, className }: TrustedByProps) => {
  const assetsData: Asset[] =
    data?.logos?.map((logo, index) => ({
      id: logo?.path ?? `trusted-by-logo-${index}`,
      width: logo?.width ?? 0,
      height: logo?.height ?? 0,
      url: withPublicImageUrl(logo?.path ?? ''),
      alt: logo?.alt ?? '',
      isSvg: hasFileExtension(logo?.path ?? '', 'svg'),
    })) ?? []

  return (
    <Section className={clsx(styles.trustedBy, className)}>
      <p className={styles.heading}>{data?.heading}</p>
      {data?.logos && data?.logos?.length > 0 && <AssetGrid assets={assetsData} />}
    </Section>
  )
}
